module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"file-upload btn-file-container\"> <div class=\"d-inline-block btn ")
    ; __append(escapeFn( locals.buttonClass ))
    ; __append(" filter-card-btn\"> ")
    ;  if (locals.uploading) { 
    ; __append(" <div class=\"loader-sm\"> <div class=\"sk-three-bounce white\"> <div class=\"sk-child sk-bounce1\"></div> <div class=\"sk-child sk-bounce2\"></div> <div class=\"sk-child sk-bounce3\"></div> </div> </div> ")
    ;  } else { 
    ; __append(" <span>")
    ; __append(escapeFn( locals.text ))
    ; __append("</span> ")
    ;  } 
    ; __append(" <input type=\"file\" class=\"read-file btn-file\" accept=\"text/csv\" title=\"attach file\"> </div> <span class=\"filename ml-2 align-middle d-inline-block\">")
    ; __append(escapeFn( locals.filename ))
    ; __append("</span> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/upload_file_button/template.ejs
// module id = 1655
// module chunks = 1